import { useNotification } from 'naive-ui'

const NotificationContent = () => {
  const notification = useNotification()

  window.$notification = notification

  return <></>
}

export default NotificationContent
